module.exports = __webpack_public_path__ + "resources/img/main_banner_gov_01.b3158b37daf9f185d0f5bfafaea1f2f6.png";